import { render } from "./EventImpactDashboard.vue?vue&type=template&id=74e08dec&scoped=true"
import script from "./EventImpactDashboard.vue?vue&type=script&lang=js"
export * from "./EventImpactDashboard.vue?vue&type=script&lang=js"

import "./EventImpactDashboard.vue?vue&type=style&index=0&id=74e08dec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e08dec"]])

export default __exports__